var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Text from "../Text/Text";
import styled from "styled-components";
import { useTheme } from "../ThemeProvider/ThemeProvider";
var StyledLink = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: fit-content;\n  text-decoration: ", ";\n  color: ", ";\n  cursor: pointer;\n  display: inline-block;\n  &:hover {\n    text-decoration: ", ";\n  }\n  &:focus-visible {\n    outline: 1px solid ", ";\n    outline-offset: 2px;\n    border-radius: 0.25rem;\n  }\n"], ["\n  width: fit-content;\n  text-decoration: ", ";\n  color: ", ";\n  cursor: pointer;\n  display: inline-block;\n  &:hover {\n    text-decoration: ", ";\n  }\n  &:focus-visible {\n    outline: 1px solid ", ";\n    outline-offset: 2px;\n    border-radius: 0.25rem;\n  }\n"])), function (props) {
    return props.$variant === "underline" ? "underline" : "none";
}, function (props) { return props.$color; }, function (props) {
    return props.$variant === "default" ? "none" : "underline";
}, function (props) { return props.$color; });
var Link = function (_a) {
    var href = _a.href, children = _a.children, _b = _a.variant, variant = _b === void 0 ? "default" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, className = _a.className, target = _a.target, style = _a.style, color = _a.color, tabIndex = _a.tabIndex, 
    // Events
    onClick = _a.onClick;
    var colorPalette = useTheme().theme.colorPalette;
    var _color = color
        ? colorPalette[color].accentScale[10]
        : colorPalette.primary.grayScale[11];
    var _handleKeyDown = function (e) {
        if (e.key === "Enter" || e.key === " ") {
            onClick && onClick(e);
        }
    };
    return (_jsx(StyledLink, __assign({ tabIndex: tabIndex, "$color": _color, "$variant": variant, target: target, href: href, className: className, style: style, onClick: onClick, onKeyDown: _handleKeyDown }, { children: typeof children === "string" ? (_jsx(Text, __assign({ noColor: true, size: size, variant: "span" }, { children: children }))) : (children) })));
};
export default Link;
var templateObject_1;
